import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import { useAuthContext } from '../hooks';
import { hasSupervisorPermission } from '../../utils/check-permission';

// ----------------------------------------------------------------------

// Gate rotte in base a un permesso del profilo Responsabile (es. requests_view).
// Complementa il gate del menu: qui blocca l'accesso via URL diretto.
// Va usato dentro <AuthGuard>, che ha già risolto l'autenticazione.
export default function SupervisorPermissionGuard({ permission, children }) {
  const { loading, user } = useAuthContext();

  if (loading) {
    return null;
  }

  if (!hasSupervisorPermission(user, permission)) {
    return <Navigate to={paths.dashboard.root} replace />;
  }

  return <>{children}</>;
}

SupervisorPermissionGuard.propTypes = {
  permission: PropTypes.string.isRequired,
  children: PropTypes.node,
};
